import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import Modal from "components/Modal";
import LogoutButtonLink from "components/ActionItem/LogoutButtonLink";
import Button from "components/Button";

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  margin-top: 1.25rem;
  width: 100%;

  ${({ theme }) => theme.mq.sm`
    display: flex;
    flex-direction: row;
    margin-top: 2.5rem;
  `}
`;

const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 31.25rem;
`;

const Title = styled.div`
  align-self: flex-start;
  font-size: 1.5rem;
  line-height: 1.75rem;
  margin-top: 0.5em;
  font-weight: 600;

  ${({ theme }) => theme.mq.sm`
  font-size: 2rem;
  margin: 0;
  line-height: 2.375rem;
  `}
`;

const GoBackButton = styled(Button)`
  background-color: transparent;
  border: 0.0625rem solid ${({ theme }) => theme.themeColors.darkGreen4};
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  margin: 0.9375rem 0 0;

  ${({ theme }) => theme.mq.sm`
    margin: 0 1.0625rem 0 0;
  `}
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: 1rem;
  font-weight: 400;
  margin: 0.9375rem 0 0.9375rem 0;
`;

const renderSubtitleText = (userTypeToAccess) => {
  if (userTypeToAccess === "customer") {
    return (
      <>
        It looks like you’re currently logged in as a provider.
        <br /> To book an appointment on GoodFriend, please log out, then sign
        in again with a customer account.
      </>
    );
  }
  return (
    <>
      It looks like you’re currently logged in as a customer.
      <br /> To list your business on GoodFriend, please log out, then sign in
      again with a provider account.
    </>
  );
};

function ChangeRoleModal({ close, show, userTypeToAccess }) {
  return (
    <Modal close={close} show={show}>
      <ContentWrapper>
        <Title>
          Hmm... This is only available <br /> to {userTypeToAccess} accounts
        </Title>
        <Subtitle>{renderSubtitleText(userTypeToAccess)}</Subtitle>
        <ButtonWrapper>
          <GoBackButton onClick={close}>Go Back</GoBackButton>
          <LogoutButtonLink
            isButton
            fontSize="1rem"
            textContent="Log out and continue"
            redirectUrl={`/${userTypeToAccess}/auth`}
          />
        </ButtonWrapper>
      </ContentWrapper>
    </Modal>
  );
}

export default ChangeRoleModal;

ChangeRoleModal.propTypes = {
  close: PropTypes.func,
  show: PropTypes.bool,
  userTypeToAccess: PropTypes.string,
};

ChangeRoleModal.defaultProps = {
  close: () => {},
  show: false,
  userTypeToAccess: "provider",
};
